import * as THREE from 'three';
import Application from '../Application';
export default class Hitboxes {
    constructor() {
        this.meshes = [];
        this.currentHover = null;
        // Raw pixel mouse position — updated live
        this.mouseRaw = { x: 0, y: 0 };
        this.items = [
            {
                name: 'coffeeMug',
                label: '☕  Dark roast, always hot',
                position: new THREE.Vector3(1670, 80, 900),
                size: new THREE.Vector3(260, 320, 260),
                color: '#a47551',
                toast: { icon: '☕', message: 'Fuelled by coffee and curiosity.' },
            },
            {
                name: 'keyboard',
                label: '⌨  Click to hear the keys',
                position: new THREE.Vector3(0, -500, 700),
                size: new THREE.Vector3(1600, 100, 500),
                color: '#3478f6',
                toast: { icon: '⌨', message: 'Typed 2.4 million keystrokes this year.' },
            },
            {
                name: 'books',
                label: '📚  Reading list — click to open Notes',
                position: new THREE.Vector3(-2000, 600, 0),
                size: new THREE.Vector3(320, 900, 540),
                color: '#30d158',
                toast: { icon: '📚', message: 'Opening Notes...' },
                macApp: 'notes',
            },
            {
                name: 'mouse',
                label: '🖱  Magic Mouse',
                position: new THREE.Vector3(900, -500, 700),
                size: new THREE.Vector3(300, 100, 400),
                color: '#8e8e93',
                toast: { icon: '🖱', message: 'The scroll wheel is a myth.' },
            },
        ];
        this.application = new Application();
        this.scene = this.application.scene;
        this.camera = this.application.camera;
        this.sizes = this.application.sizes;
        this.createTooltip();
        this.createHitboxes();
        this.initListeners();
    }
    /* ─── Tooltip DOM ─── */
    createTooltip() {
        this.tooltip = document.createElement('div');
        this.tooltip.className = 'desk-tooltip';
        document.body.appendChild(this.tooltip);
    }
    /* ─── Invisible hitbox meshes ─── */
    createHitboxes() {
        this.items.forEach(item => {
            const mat = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0, depthWrite: false });
            const geo = new THREE.BoxGeometry(item.size.x, item.size.y, item.size.z);
            const mesh = new THREE.Mesh(geo, mat);
            mesh.name = item.name;
            mesh.position.copy(item.position);
            this.scene.add(mesh);
            this.meshes.push(mesh);
        });
    }
    /* ─── NDC raycaster ─── */
    getNDC() {
        return {
            x: (this.mouseRaw.x / this.sizes.width) * 2 - 1,
            y: -(this.mouseRaw.y / this.sizes.height) * 2 + 1,
        };
    }
    getHit() {
        const ray = new THREE.Raycaster();
        ray.setFromCamera(this.getNDC(), this.camera.instance);
        const hits = ray.intersectObjects(this.meshes);
        return hits.length > 0 ? hits[0] : null;
    }
    /* ─── Toast via DOM custom event (picked up by React DeskToast) ─── */
    fireToast(icon, message, color) {
        document.dispatchEvent(new CustomEvent('deskToast', { detail: { icon, message, color } }));
    }
    /* ─── Notify macOS iframe to open an app ─── */
    openMacApp(app) {
        const iframe = document.getElementById('computer-screen');
        if (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) {
            iframe.contentWindow.postMessage({ type: 'openApp', app }, '*');
        }
    }
    /* ─── Events ─── */
    initListeners() {
        // Track raw mouse position
        document.addEventListener('mousemove', (e) => {
            // Ignore events that originated inside the iframe
            if (e.inComputer)
                return;
            this.mouseRaw.x = e.clientX;
            this.mouseRaw.y = e.clientY;
            // Move tooltip
            this.tooltip.style.left = e.clientX + 'px';
            this.tooltip.style.top = e.clientY + 'px';
            // Hover detection
            const hit = this.getHit();
            if (hit) {
                const name = hit.object.name;
                if (name !== this.currentHover) {
                    this.currentHover = name;
                    const item = this.items.find(i => i.name === name);
                    this.tooltip.textContent = item.label;
                    this.tooltip.classList.add('visible');
                    document.body.style.cursor = 'pointer';
                }
            }
            else {
                if (this.currentHover) {
                    this.currentHover = null;
                    this.tooltip.classList.remove('visible');
                    document.body.style.cursor = '';
                }
            }
        });
        // Click
        document.addEventListener('mousedown', (e) => {
            if (e.inComputer)
                return;
            const hit = this.getHit();
            if (!hit)
                return;
            const item = this.items.find(i => i.name === hit.object.name);
            if (!item)
                return;
            this.fireToast(item.toast.icon, item.toast.message, item.color);
            if (item.macApp)
                this.openMacApp(item.macApp);
        });
    }
}
